import { ReactElement } from 'react';

const ErrorPage = (): ReactElement => (
  <div>
    <h1>Error Page</h1>
  </div>
);

export default ErrorPage;
